/**
 * Token Management Utilities
 * JWT is stored in an HttpOnly cookie (set by the server), not accessible from JS.
 * This module only manages user data in localStorage.
 */

/**
 * Get authentication token (always null - token is HttpOnly cookie)
 */
export const getAuthToken = (): string | null => {
  return null;
};

/**
 * Check if user data exists in localStorage
 */
export const isAuthenticated = (): boolean => {
  return !!localStorage.getItem('user');
};

/**
 * Store user data from auth response
 */
export const storeAuthData = (_token: string, user?: Record<string, unknown>): void => {
  if (user) {
    localStorage.setItem('user', JSON.stringify(user));
  }
};

/**
 * Clear all auth data
 */
export const clearAuthData = (): void => {
  localStorage.removeItem('user');
};
